<!-- <ng-container *ngIf="syncingOrdersToM3">
    <div class="custom-loader-overlay">
        <div class="custom-loader-container">
            <div class="custom-loader"></div>
            <div class="loader-message">
                <div>Syncing orders with M3</div>
                <div>Please wait...</div>
            </div>
        </div>
    </div>
</ng-container>
<div *ngIf="loading" class="custom-loader-overlay">
    <div class="custom-loader-container">
        <div class="custom-loader"></div>
        <div class="loader-message">
            <div>Getting order Data</div>
            <div>Please wait...</div>
        </div>
    </div>
</div> -->

<div *ngIf="loading" class="custom-loader-overlay">
    <div class="custom-loader-container">
        <div class="custom-loader"></div>
        <div class="loader-message">
            <div>{{ loaderMessageLine1 }}</div>
            <div>{{ loaderMessageLine2 }}</div>
        </div>
    </div>
</div>
<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>
<div *ngIf="canAccess">
    <div class="sticky-toolbar mb-3 text-[14px]">
        <p-toolbar class="text-[14px] p-0">
            <ng-template #start [disabled]="draftDialogVisible">
                <p-button label="New" icon="pi pi-plus" severity="secondary" class="mr-2" (onClick)="openNew()" />
                <!-- <p-button label="Sales Management" icon="pi pi-plus" severity="secondary" class="mr-2"
                (onClick)="salesManagement()" /> -->
                <ng-container *ngIf="userService.getDivisionId() === '400'">
                    <p-button *ngIf="isManagerOrSuperUser" label="Sync Orders to M3" icon="pi pi-cloud-upload" severity="secondary" class="mr-2" (onClick)="onSyncAllOrders()" />
                </ng-container>
                <p-button label="Combined Picking list" icon="pi pi-list" severity="secondary" class="mr-2" (onClick)="showCombineDialog = true" />
                <p-button *ngIf="isManagerOrSuperUser" label="Export to Excel" icon="pi pi-file-excel" severity="secondary" class="mr-2" (onClick)="openExportPdfDialog()" />

                <!-- <p-button label="Delete" icon="pi pi-trash" severity="secondary" outlined (onClick)="deleteSelectedProducts()" [disabled]="!selectedProducts || !selectedProducts.length" /> -->
            </ng-template>

            <ng-template #end [disabled]="draftDialogVisible">
                <p-button *ngIf="isManagerOrSuperUser" label="Assign Target" icon="pi pi-bullseye" severity="secondary" class="ml-2" [routerLink]="['/team-details', 1]"> </p-button>
                <p-button *ngIf="isManagerOrSuperUser" label="Route Wise Picking List" icon="pi pi-cog" severity="secondary" class="mr-2" (click)="openRouteWisePickingList()"> </p-button>
            </ng-template>
        </p-toolbar>
    </div>
    <!-- <div (contextmenu)="onRightClick($event)">Right click here</div> -->
    <p-contextMenu #cm [model]="contextMenuItems"></p-contextMenu>

    <p-table
        #dt
        [value]="products()"
        [rows]="40"
        [paginator]="true"
        [contextMenu]="cm"
        (onContextMenuSelect)="onRowSelect($event)"
        [(selection)]="selectedProducts"
        [tableStyle]="{ 'min-width': '75rem' }"
        [rowHover]="true"
        dataKey="id"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} products"
        [showCurrentPageReport]="true"
        [globalFilterFields]="['orderNumber', 'type', 'referenceOrderId', 'orderMovingStatus', 'customerName', 'tornaOrderDate', 'userIdResponsible', 'status', 'address', 'orderType', 'facility', 'warehouse', 'tornaOrderDate']"
        [rowsPerPageOptions]="[40, 100, 250, 500, 1000, 2000]"
        [scrollable]="true"
        [scrollHeight]="'65vh'"
    >
    
        <ng-template #caption>
            <div class="flex justify-between items-center flex-wrap gap-2 w-full">
                <!-- Left Controls: Date Range, Total Remaining -->
                <div class="flex items-center gap-1 flex-wrap">
                    <h5 class="m-0">Manage Orders</h5>
                    <p-button label="Refresh" icon="pi pi-refresh" severity="secondary" class="mr-2" (onClick)="refreshOrders()" />
                </div>

                <!-- Right Controls: Action Buttons -->
                <div class="flex items-center gap-1">
                    <!-- <button pButton type="button" label="Create Picking List" icon="pi pi-plus" [severity]="'primary'" [disabled]="!selectedOrders.length" class="mr-2" (click)="openDialog()"></button>
                <button pButton type="button" label="Add in Existing Picklist" icon="pi pi-folder" [severity]="'primary'" [disabled]="!selectedOrders.length" (click)="fetchPickingListsByDate()"></button> -->
                    <button pButton label="Clear Filters" class="p-button-outlined" icon="pi pi-filter-slash" (click)="clear(dt)"></button>

                    <p-iconfield>
                        <p-inputicon styleClass="pi pi-search" />
                        <input pInputText type="text" (input)="onGlobalFilter(dt, $event)" placeholder="Search..." />
                    </p-iconfield>
                </div>
            </div>
        </ng-template>

        <ng-template pTemplate="header">
            <tr>
                <!-- <th style="width: 3rem">
                <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
            </th> -->
                <th pSortableColumn="orderNumber" pFrozenColumn style="min-width: 150px; max-width: 160px">Order Number <p-sortIcon field="orderNumber" /></th>
                <th pSortableColumn="name" style="min-width: 250px; max-width: 350px">Customer <p-sortIcon field="name" /></th>

                <!-- <th  pSortableColumn="referenceOrderId" style="min-width: 180px; max-width: 180px">Reference Order ID <p-sortIcon field="referenceOrderId" /></th> -->

                <!-- <th pSortableColumn="status" style="min-width: 140px; max-width: 300px;">Status <p-sortIcon
                    field="status" /></th> -->

                <th pSortableColumn="status" style="min-width: 160px; max-width: 320px">
                    Sync Status
                    <p-sortIcon field="status" />
                    <p-columnFilter type="numeric" field="status" display="menu" placeholder="Filter" [showOperator]="false" style="width: 100px" />
                </th>
                <th pSortableColumn="orderMovingStatus" style="min-width: 140px; max-width: 300px">
                    Moving Status
                    <p-sortIcon field="orderMovingStatus" />
                    <!-- <p-columnFilter type="numeric" field="MovingStatus" display="menu" placeholder="Filter" [showOperator]="false" style="width: 100px" /> -->
                </th>
                <th pSortableColumn="SyncToM3" style="min-width: 80px; max-width: 100px">Sync to M3</th>
                <th pSortableColumn="PickList" style="min-width: 80px; max-width: 100px">PickList</th>

                <th pSortableColumn="Invoice" *ngIf="isManagerOrSuperUser" style="min-width: 80px; max-width: 100px">Invoice</th>

                <th pSortableColumn="referenceOrderId" style="min-width: 180px; max-width: 180px">Reference Order ID <p-sortIcon field="referenceOrderId" /></th>
                <!-- 
                <th pSortableColumn="RequestedDate" style="min-width: 180px; max-width: 210px">Requested Date 
                    <p-sortIcon field="RequestedDate" />
                    <p-columnFilter type="date" field="RequestedDate" display="menu" placeholder="Filter" [showOperator]="false" style="width: 100px" />
                </th> -->
                <th pSortableColumn="tornaOrderDateObj" style="min-width: 210px; max-width: 230px">
                    Torna Order Date
                    <p-sortIcon field="tornaOrderDateObj" />
                    <p-columnFilter type="date" field="tornaOrderDateObj" display="menu" placeholder="Filter" [showOperator]="false" style="width: 100px" />
                </th>

                <th pSortableColumn="invoiceDate" style="min-width: 180px; max-width: 210px">
                    Invoice Date
                    <p-sortIcon field="invoiceDate" />
                    <p-columnFilter type="date" field="invoiceDate" display="menu" placeholder="Filter" [showOperator]="false" style="width: 100px" />
                </th>
                <th pSortableColumn="type" style="min-width: 130px; max-width: 150px">Order Type <p-sortIcon field="type" /></th>
                <th pSortableColumn="category" style="min-width: 110px; max-width: 150px">Facility <p-sortIcon field="category" /></th>
                <th pSortableColumn="price" style="min-width: 120px; max-width: 150px">Warehouse <p-sortIcon field="price" /></th>

                <th pSortableColumn="userIdResponsible" style="min-width: 160px; max-width: 180px">User Responsible <p-sortIcon field="userIdResponsible" /></th>
                <!-- <th pSortableColumn="Total Articles" style="min-width: 120px; max-width: 150px">Total Articles <p-sortIcon field="Total Articles" /></th> -->

                <th pSortableColumn="grossValue" style="min-width: 120px; max-width: 150px">Gross Value <p-sortIcon field="grossValue" /></th>
                <th pSortableColumn="totalDiscountValue" style="min-width: 140px; max-width: 150px" *ngIf="division !== '400'">Total Discount <p-sortIcon field="totalDiscountValue" /></th>
                <th pSortableColumn="netAmount" style="min-width: 130px; max-width: 150px">Net Amount <p-sortIcon field="netAmount" /></th>
                <th pSortableColumn="vatAmount" style="min-width: 130px; max-width: 150px">VAT Amount <p-sortIcon field="vatAmount" /></th>

                <th pSortableColumn="orderValue" style="min-width: 130px; max-width: 150px">Order Value <p-sortIcon field="orderValue" /></th>

                <!-- <th style="min-width: 120px; max-width: 140px;">Actions</th> -->
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-product>
            <tr [pSelectableRow]="product" (contextmenu)="onRightClick($event, product)">
                <!-- <td style="width: rem">
                <p-tableCheckbox [value]="product" />
            </td> -->
                <td pFrozenColumn>
                    <a href="#" (click)="onDisplay(product, $event)" class="text-blue-600 hover:underline">
                        {{ product.orderNumber }}
                    </a>
                </td>
                <td>
                    <a href="#" (click)="onDisplay(product, $event)" class="text-blue-600 hover:underline">
                        {{ product.customerName }}
                    </a>
                    <!-- <a [routerLink]="['/item', product.id]" [state]="{ product: product }" class="text-blue-600 hover:underline">
                        {{ product.customerName }}
                    </a> -->
                </td>

                <td>
                    <ng-container *ngIf="product.status == 15; else normalStatus">
                        <span style="display: flex; align-items: center; gap: 0.5em">
                            <span class="p-badge p-badge-warning" style="font-size: 1.1em"> 15 </span>
                            <i
                                class="pi pi-exclamation-triangle"
                                style="font-size: 1.5em; color: #ef0f0f; cursor: pointer"
                                [pTooltip]="product.errorMessage || product.errorMessages || 'Error in the order line after validation'"
                                tooltipPosition="top"
                            ></i>
                            <button type="button" style="background: none; border: none; padding: 0; margin: 0; cursor: pointer" (click)="onSyncOrder(product); $event.stopPropagation()">
                                <i class="pi pi-sync" style="font-size: 1.5em; color: #2563eb" title="Sync"></i>
                            </button>
                        </span>
                    </ng-container>
                    <ng-template #normalStatus>
                        {{ product.status }}
                    </ng-template>
                </td>
                <td>{{ product.orderMovingStatus }}</td>
                <td><button pButton icon="pi pi-cloud-upload" class="p-button-text p-mr-2" (click)="onSyncOrder(product); $event.stopPropagation()"></button></td>
                <td><button pButton icon="pi pi-print" class="p-button-text p-mr-2" (click)="openPickingList(product.orderNumber, product.customerName)"></button></td>
                <td *ngIf="isManagerOrSuperUser"><button pButton icon="pi pi-print" class="p-button-text p-mr-2" (click)="showInvoiceConfirm(product.orderNumber, product.orderMovingStatus, product.customerName)"></button></td>
                <td>{{ product.referenceOrderId }}</td>
                <!-- <td>{{ product.requestedDate }}</td> -->
                <td>
                    {{ product.orderCreatedDate }}
                </td>
                <td>{{ product.invoiceDate | date:'dd-MMM-yyyy' }}</td>
                <td>{{ product.orderType }}</td>
                <td>{{ product.facility }}</td>
                <td>{{ product.warehouse }}</td>

                <td>{{ product.userIdResponsible }}</td>
                <!-- <td>{{ product.totalArticles }}</td> -->
                <td>{{ product.grossValue }}</td>
                <td *ngIf="division !== '400'">{{ product.totalDiscountValue }}</td>
                <td>{{ product.netAmount }}</td>
                <td>{{ product.vatAmount }}</td>
                <td>{{ product.orderValue }}</td>

                <!--  
            <td>
                <p-button  icon="pi pi-fw pi-user-edit" class="mr-2" [outlined]="true"
                    (onClick)="editProduct(product)" />
               <p-button  icon="pi pi-trash" severity="danger" [outlined]="true"
                    (onClick)="deleteProduct(product)" />
             </td> -->
            </tr>
        </ng-template>
    </p-table>
    <!-- Dialog for New/Edit -->
    <p-dialog [(visible)]="productDialog" [style]="{ width: '450px' }" header="Order Header" [modal]="true">
        <ng-template #content>
            <!-- Customer -->
            <div class="field mb-4">
                <label for="customer" class="block font-bold mb-2">Select Customer</label>
                <p-autoComplete
                    [(ngModel)]="selectedCustomer"
                    [suggestions]="customerOptions"
                    (completeMethod)="filterCustomers($event)"
                    field="CUSTOMER"
                    [style]="{ width: '100%' }"
                    [panelStyle]="{ minWidth: '520px', maxWidth: 'min(90vw, 720px)' }"
                    panelStyleClass="customer-autocomplete-panel"
                    appendTo="body"
                    (onSelect)="onCustomerSelect($event)"
                    [dropdown]="true"
                    [placeholder]="'Select a customer Please enter at least 3 characters'"
                    #customerField
                    (keydown.enter)="focusFacilityInput()"
                ></p-autoComplete>
                <!-- <small class="text-yellow-500" *ngIf="submitted && product.customer && product.customer.length < 3">Please enter at least 3 characters.</small> -->
                <small class="text-red-500" *ngIf="submitted && !product.customer">Customer is required.</small>
            </div>

            <!-- Facility -->
            <div class="field mb-4">
                <label for="facility" class="block font-bold mb-2">Facility</label>
                <p-autoComplete
                    inputId="facility"
                    #facilityField
                    [(ngModel)]="product.facilityId"
                    [suggestions]="filteredFacilities"
                    (completeMethod)="filterFacilities($event)"
                    [dropdown]="true"
                    [field]="'label'"
                    [optionLabel]="'label'"
                    [optionValue]="'value'"
                    [placeholder]="'Select facility'"
                    [style]="{ width: '100%' }"
                    [forceSelection]="true"
                    (keydown.enter)="focusWarehouseInput()"
                    appendTo="body"
                    (ngModelChange)="onFacilityChange($event)"
                >
                </p-autoComplete>
                <small class="text-red-500" *ngIf="submitted && !product.facilityId">Facility is required.</small>
            </div>
            <!-- Warehouse -->
            <div class="field mb-4">
                <label for="warehouse" class="block font-bold mb-2">Warehouse</label>
                <p-autoComplete
                    inputId="warehouse"
                    #warehouseField
                    [(ngModel)]="product.warehouseId"
                    [suggestions]="filteredWarehouses"
                    (completeMethod)="filterWarehouses($event)"
                    [dropdown]="true"
                    [field]="'label'"
                    [optionLabel]="'label'"
                    [optionValue]="'value'"
                    [placeholder]="'Select warehouse'"
                    [style]="{ width: '100%' }"
                    [forceSelection]="true"
                    (keydown.enter)="focusOrderTypeInput()"
                    (onSelect)="onWarehouseSelect($event)"
                    appendTo="body"
                >
                </p-autoComplete>
                <small class="text-red-500" *ngIf="submitted && !product.warehouseId">Warehouse is required.</small>
            </div>

            <!-- Order Type -->
            <div class="field mb-4">
                <label for="orderType" class="block font-bold mb-2">Order Type</label>
                <p-autoComplete
                    #orderTypeField
                    inputId="orderType"
                    [(ngModel)]="product.orderTypeId"
                    [suggestions]="filteredOrderType"
                    (completeMethod)="filterOrderType($event)"
                    [dropdown]="true"
                    [optionLabel]="'label'"
                    [optionValue]="'value'"
                    [placeholder]="'Select Order Type'"
                    [style]="{ width: '100%' }"
                    [forceSelection]="true"
                    (keydown.enter)="focusAddressInput()"
                    appendTo="body"
                ></p-autoComplete>
                <small class="text-red-500" *ngIf="submitted && !product.orderTypeId">Order Type is required.</small>
            </div>
            <!-- Address -->
            <div class="field mb-4">
                <label for="address" class="block font-bold mb-2">Select Address</label>
                <p-autoComplete
                    #addressField
                    [(ngModel)]="product.address"
                    [suggestions]="filteredAddresses"
                    (completeMethod)="filterAddresses($event)"
                    [dropdown]="true"
                    [placeholder]="'Select an address'"
                    [style]="{ width: '100%' }"
                    [forceSelection]="true"
                    appendTo="body"
                    field="label"
                    (onSelect)="onAddressChanged($event)"
                    (keydown.enter)="tornaOrderDateField.focus()"
                ></p-autoComplete>
                <!-- <small class="text-red-500" *ngIf="submitted && !product.address">Address is required.</small> -->
            </div>
            <!-- Torna Order Date -->
            <div>
                <label for="tornaOrderDate" class="block font-bold mb-2">Torna Order Date</label>
                <input type="date" [min]="today" id="tornaOrderDate" [(ngModel)]="product.tornaOrderDate" required class="border p-2 w-full" #tornaOrderDateField (keydown.enter)="focusSubmitButton()" />
                <small class="text-red-500" *ngIf="submitted && !product.tornaOrderDate">Torna Order Date is required.</small>
            </div>
        </ng-template>

        <ng-template #footer>
            <p-button label="Cancel" icon="pi pi-times" text (click)="hideDialog()" />
            <button
                pButton
                #submitButton
                label="Proceed"
                icon="pi pi-check"
                (click)="saveProduct()"
                [ngClass]="{ 'p-button-outlined': !isFocused }"
                (focus)="isFocused = true"
                (blur)="isFocused = false"
                (mouseenter)="isFocused = true"
                (mouseleave)="isFocused = false"
            ></button>
        </ng-template>
    </p-dialog>

    <p-dialog [(visible)]="draftDialogVisible" [style]="{ width: '450px' }" header="Draft Order Found" (onHide)="onDraftDialogHide()" closable="false" [modal]="true" [blockScroll]="true">
        <ng-template #content>
            <div class="text-center">
                <p>We found an unsaved order. Would you like to continue where you left off?</p>
            </div>
        </ng-template>
        <ng-template #footer>
            <p-button label="Discard" icon="pi pi-times" text (click)="discardDraft(); draftDialogVisible = false" />
            <p-button label="Continue" icon="pi pi-check" (click)="continueDraft(); draftDialogVisible = false" />
        </ng-template>
    </p-dialog>

    <p-dialog [(visible)]="statusHelpDialog" header="Status Help" [modal]="true" [style]="{ width: '400px' }">
        <div>
            <p><b>Status 9:</b> The order is kept on hold.</p>
            <p><b>Status 10:</b> The order is created and ready to sync in M3.</p>
            <p><b>Status 15:</b> There was some error or issue while syncing in M3.</p>
            <p><b>Status 20:</b> The order is synced with M3.</p>
        </div>
    </p-dialog>
    <p-dialog header="Combined Picking List Filters" [(visible)]="showCombineDialog" [modal]="true" [style]="{ width: '350px', height: '350px' }">
        <div class="p-fluid">
            <div class="field mb-3" style="display: flex; align-items: center">
                <label for="pickingListType" style="width: 110px; margin-right: 8px">Picking List Type</label>
                <p-dropdown
                    id="pickingListType"
                    [options]="pickingListTypes"
                    [(ngModel)]="combineDialogData.pickingListType"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="Select Type"
                    [style]="{ flex: '1' }"
                    [panelStyle]="{ minWidth: '200px' }"
                ></p-dropdown>
            </div>
            <div class="field mb-3" style="display: flex; align-items: center">
                <label style="width: 110px; margin-right: 8px">From Date</label>
                <input type="date" [(ngModel)]="combineDialogData.fromDate" class="p-inputtext p-component" style="flex: 1" placeholder="YYYY-MM-DD" lang="en-CA" />
            </div>
            <div class="field mb-3" style="display: flex; align-items: center">
                <label style="width: 110px; margin-right: 8px">To Date</label>
                <input type="date" [(ngModel)]="combineDialogData.toDate" class="p-inputtext p-component" style="flex: 1" placeholder="YYYY-MM-DD" lang="en-CA" />
            </div>
            <div class="field mb-3" style="display: flex; align-items: center">
                <label style="width: 110px; margin-right: 8px">Status</label>
                <p-dropdown
                    [options]="orderStatuses"
                    [(ngModel)]="combineDialogData.orderStatus"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="Select Status"
                    [style]="{ flex: '1' }"
                    [panelStyle]="{ minWidth: '200px' }"
                    appendTo="body"
                ></p-dropdown>
            </div>
        </div>
        <ng-template #footer>
            <p-button label="Cancel" icon="pi pi-times" text (click)="showCombineDialog = false"></p-button>
            <p-button label="Proceed" icon="pi pi-check" (click)="onCombinePickingListProceed()"></p-button>
        </ng-template>
    </p-dialog>
</div>
<p-dialog [(visible)]="confirmInvoiceDialogVisible" [style]="{ width: '400px' }" header="Confirm Invoice" [modal]="true">
    <ng-template pTemplate="content">
        <div class="text-center">
            <p>
                Printing invoice will change the order status to <b>INV</b>.<br />
                Are you sure you want to continue?
            </p>
        </div>
    </ng-template>
    <ng-template pTemplate="footer">
        <p-button label="Cancel" icon="pi pi-times" text (click)="confirmInvoiceDialogVisible = false"></p-button>
        <p-button label="OK" icon="pi pi-check" (click)="confirmInvoiceDialogVisible = false; generateInvoice(selectedOrderNumber, selectedCustomerName)"></p-button>
    </ng-template>
</p-dialog>
<!-- <p-dialog [(visible)]="exportPdfDialogVisible" [modal]="true" header="Export Orders to Excel" [style]="{ width: '300px' }">
    <div class="p-fluid grid gap-3">
   
        <div class="col-6">
            <label for="exportFromDate" class="block font-bold mb-2">From Date</label>
            <input type="date" id="exportFromDate" [(ngModel)]="exportFromDate" [max]="getTodayDate()" class="p-inputtext p-component w-full" />
        </div>

      
        <div class="col-6">
            <label for="exportToDate" class="block font-bold mb-2">To Date</label>
            <input type="date" id="exportToDate" [(ngModel)]="exportToDate" [max]="getTodayDate()" class="p-inputtext p-component w-full" />
        </div>
    </div>

    <ng-template #footer>
        <p-button label="Cancel" icon="pi pi-times" text (click)="exportPdfDialogVisible = false"></p-button>
        <p-button label="Export" icon="pi pi-file-excel" [loading]="exportPdfLoading" (click)="onExportPdf()"></p-button>
    </ng-template>
</p-dialog> -->

<p-dialog [(visible)]="exportPdfDialogVisible" [modal]="true" header="Export Orders to Excel" [style]="{ width: '300px' }">
    <div class="p-fluid grid gap-3">
        <!-- Export Type -->
        <div class="col-12">
            <label for="exportType" class="block font-bold mb-2">Export Type</label>
            <p-dropdown
                id="exportType"
                [(ngModel)]="exportExportType"
                [options]="[
                    { label: 'Order Headers + Lines', value: 'lines' },
                    { label: 'Order Headers Only', value: 'headers' }
                ]"
                placeholder="Select export type"
                class="w-full"
            >
            </p-dropdown>
        </div>
        <!-- From Date -->
        <div class="col-6">
            <label for="exportFromDate" class="block font-bold mb-2">From Date</label>
            <input type="date" id="exportFromDate" [(ngModel)]="exportFromDate" [max]="getTodayDate()" class="p-inputtext p-component w-full" />
        </div>
        <!-- To Date -->
        <div class="col-6">
            <label for="exportToDate" class="block font-bold mb-2">To Date</label>
            <input type="date" id="exportToDate" [(ngModel)]="exportToDate" [max]="getTodayDate()" class="p-inputtext p-component w-full" />
        </div>
    </div>
    <ng-template #footer>
        <p-button label="Cancel" icon="pi pi-times" text (click)="exportPdfDialogVisible = false"></p-button>
        <p-button label="Export" icon="pi pi-file-excel" [loading]="exportPdfLoading" (click)="onExportPdf()"></p-button>
    </ng-template>
</p-dialog>

<!-- Example for facility dropdown -->
<!-- <p-dropdown 
    [options]="filteredFacilities" 
    [(ngModel)]="product.facilityId"
    [disabled]="facilityLoading">
</p-dropdown>
<p-progressSpinner *ngIf="facilityLoading" styleClass="facility-loader" [style]="{width: '30px', height: '30px'}"></p-progressSpinner> -->
